import { RouteConfig } from 'vue-router';

import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const settingEditRoute: RouteConfig = {
  path: 'edit/:settingId',
  name: 'settingEdit',
  component: () => import(/* webpackChunkName: "SettingEditList" */ '@/views/mainRoute/setting/Edit.vue'),
  props: {
    from: {}
  },
  meta: {
    breadcrumb: { title: 'Edycja ustawienia' }
  },
  beforeEnter(to, from, next) {
    // tslint:disable-next-line
    settingEditRoute.props ? (settingEditRoute.props = { from }) : undefined;
    store
      .dispatch('setting/get', tryParseInt(to.params.settingId))
      .then(setting =>
        store.dispatch('setting/attachment/list', { entityType: EntityType.SETTING, entityId: setting.id.toString() })
      )
      .then(() => {
        next();
      })
      .catch(err => store.dispatch('notifyError', { title: Errors.SETTING_CANNOT_GET }));
  }
};
